
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/panier",
      function () {
        return require("private-next-pages/shop/panier.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/panier"])
      });
    }
  